// geoip-popup.js

const apiKey = '95fa56adf3871adeac46c7be65b930ee47da1760d71987c052b2eee9';

function setCookie(name, value, days, samesite = 'Lax') {
    const d = new Date();
    d.setTime(d.getTime() + (days * 24 * 60 * 60 * 1000));
    const expires = "expires=" + d.toUTCString();
    document.cookie = `${name}=${value};${expires};path=/;SameSite=${samesite}`;
}

function getCookie(name) {
    const nameEQ = name + "=";
    const ca = document.cookie.split(';');
    for(let i = 0; i < ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) == ' ') c = c.substring(1, c.length);
        if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
    }
    return null;
}

function showPopup(message, imgUrl, redirectUrl) {
    console.log('Showing popup:', message); // Debug log
    const popup = document.createElement('div');
    popup.id = 'geoip-popup';
    popup.innerHTML = `
        <div id="geoip-popup-content">
            <img src="${imgUrl}" alt="Flag" style="width: 150px; height: auto; display: block; margin: 0 auto 30px;">
            <p>${message}</p>
            <button id="geoip-switch-site">Yes</button>
            <button id="geoip-stay-site">No, stay here</button>
        </div>
    `;
    document.body.appendChild(popup);

    document.getElementById('geoip-switch-site').onclick = () => {
        window.location.href = redirectUrl;
    };

    document.getElementById('geoip-stay-site').onclick = () => {
        setCookie('geoip-popup-dismissed', 'true', 15); // Set cookie for 15 days
        document.body.removeChild(popup);
    };
}

// Function to get the visitor's IP data
async function getIpData() {
    try {
        const response = await fetch(`https://api.ipdata.co?api-key=${apiKey}`);
        const data = await response.json();
        console.log('IP data fetched:', data); // Debug log
        return data;
    } catch (error) {
        console.error('Error fetching IP data:', error);
        return null;
    }
}

// Function to handle the logic based on the IP data
async function handleGeoIp() {
    if (getCookie('geoip-popup-dismissed') || getCookie('geoip-correct-site')) {
        console.log('Popup dismissed or correct site previously'); // Debug log
        return;
    }

    const ipData = await getIpData();
    if (!ipData) return;

    const country = ipData.country_code;
    console.log('Country code:', country); // Debug log

    const canadianSite = 'https://budgetshelves.com';
    const usSite = 'https://us.budgetshelves.com';

    if (country === 'CA' && window.location.hostname === 'us.budgetshelves.com') {
        showPopup(
            'It looks like you are visiting from Canada. Would you like to switch to our Canadian site?', 
            'https://cdn.shopify.com/s/files/1/0878/5838/1113/files/Flag_of_Canada__Pantone__svg.png?v=1719334880', 
            canadianSite
        );
    } else if (country === 'US' && window.location.hostname === 'budgetshelves.com') {
        showPopup(
            'It looks like you are visiting from the US. Would you like to switch to our US site?', 
            'https://cdn.shopify.com/s/files/1/0878/5838/1113/files/Flag_of_the_United_States__DoS_ECA_Color_Standard__svg.png?v=1719331201', 
            usSite
        );
    } else {
        // Set cookie for users on the correct site
        setCookie('geoip-correct-site', 'true', 15); // Set cookie for 15 days
    }
}

// Call the function when the page loads
window.onload = () => {
    if (!getCookie('geoip-popup-dismissed') && !getCookie('geoip-correct-site')) {
        handleGeoIp();
    } else {
        console.log('GeoIP check skipped due to cookie');
    }
};
